<template>
    <div class="container-fluid content-wrapper">
        <b-row class="content-heading">
            <b-col>
                <div>Departments, Classes, and Categories</div>
            </b-col>
            <b-col cols="auto" class="ms-auto">
                <b-button type="submit" form="dcc-edit-form" variant="primary">Save</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
            <b-button variant="primary"
                      class="ms-3 mb-2"
                      @click="addNewDccClick()">
                    <b-icon-plus></b-icon-plus>
                Add DCC
            </b-button>
            <b-button variant="primary"
                      @click="addNewClassAndCategoryClick()"
                      v-show="departmentSelected"
                      class="ms-3 mb-2">
                <b-icon-plus></b-icon-plus>Add Class and Category</b-button>
            <b-button variant="primary"
                      @click="addNewCategoryClick()"
                      v-show="classSelected"
                      class="ms-3 mb-2">
                <b-icon-plus></b-icon-plus>Add Category</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="5" sm="4" lg="3">
                <dccList :dccs="dccs"
                         :selectedDcc="selectedDcc"
                         @selectedDccChanged="selectedDccChanged"
                         class="dcc-list-window">
                </dccList>
                <b-button variant="primary"
                    class="mt-2"
                    v-show="dccs.length > 0"
                    @click="addNewDccClick()">
                <b-icon-plus></b-icon-plus>Add DCC</b-button>
                <b-button variant="primary"
                    @click="addNewClassAndCategoryClick()"
                    v-show="departmentSelected"
                    class="ms-3 mt-2">
                <b-icon-plus></b-icon-plus>Add Class and Category</b-button>
                <b-button variant="primary"
                    @click="addNewCategoryClick()"
                    v-show="classSelected"
                    class="ms-3 mt-2">
                <b-icon-plus></b-icon-plus>Add Category</b-button>
            </b-col>
            <b-col cols="7" sm="8" lg="9">
                <edit v-if="selectedDcc.department"
                      :key="selectedDccKey"
                      :selectedDcc="selectedDcc"
                      :dccs="dccs"
                      @reload-dccs="loadDccs"
                      @delete-dcc="deleteDcc"
                      ref="dccEdit"></edit>
            </b-col>
        </b-row>        
    </div>
</template>

<script>
    import axios from "axios";
    import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js'
    import dccList from "./DccList.vue";
    import edit from "./Edit.vue";

    export default {
        data() {
            return {
                dccs: [],
                selectedDcc: this.getEmptySelection(),
                displayMessage:null,
                resetValidator: false
            };
        },
        components: {
            dccList,
            edit
        },
        computed: {
            departmentSelected() {
                return (
                    this.selectedDcc.department?.dccDepartmentId &&
                    !this.selectedDcc.class
                );
            },
            classSelected() {
                return (
                    this.selectedDcc.class?.dccClassId && !this.selectedDcc.category
                );
            },
            categorySelected() {
                return this.selectedDcc.category?.dccCategoryId;
            },
            selectedDccKey() {
                // Force the Edit component to remount whenever the user selects a
                // different DCC. Vue 3's deep-watcher on the prop sometimes leaves
                // dccElements with stale data from the previously selected DCC,
                // which then overwrites the current DCC's name/number on save.
                return [
                    this.selectedDcc.department?.dccDepartmentId ?? 'newDept',
                    this.selectedDcc.class?.dccClassId ?? 'noClass',
                    this.selectedDcc.category?.dccCategoryId ?? 'noCat'
                ].join('-');
            }
        },
        methods: {
            getEmptySelection() {
                return {
                    department: null,
                    class: null,
                    category: null,
                };
            },
            async selectedDccChanged(selectedDcc) {
                if (this.$refs.dccEdit && this.$refs.dccEdit.formIsDirty){              
                    await this.$bvModal
                        .msgBoxConfirm('Are you sure you want to leave without saving?')
                        .then(value => {
                            if (!value) {
                                return;
                            } else {
                                this.selectedDcc = selectedDcc;
                            }
                        });
                }
                else {
                    this.selectedDcc = selectedDcc;
                }
            },
            async getEmptyDccLocationCOATypes()
            {
                let storeLocations = await selectListOptionsDataContext.getStoreDropdownData('locations');
                let accountTypeEntries = await selectListOptionsDataContext.getStoreDropdownData('accountTypeEntries');

                let mappedDccLocationCOATypes = {locations : storeLocations.map(location => (
                    { 
                        locationId: location.value,
                        locationName: location.text,
                        dccChartsOfAccountTypes: accountTypeEntries.map(accountTypeEntry => 
                            ({ 
                                chartOfAccountsId: 0, 
                                chartOfAccountsTypeId: accountTypeEntry.value, 
                                chartOfAccountsTypeName: accountTypeEntry.text, 
                                dccCategoryId: 0, 
                                isChanged: false 
                            }))
                    }
                ))};
                
                return mappedDccLocationCOATypes;
            },
            async getNewCategory() {
                return { 
                    isNew: true, 
                    allowsDiscounts: true,
                    dccCategoryChartOfAccountsTypes : await this.getEmptyDccLocationCOATypes()
                }
            },
            async addNewDccClick() {
                this.selectedDcc = {
                    department: { isNew: true },
                    class: { isNew: true, dccCategories: [{dccCategoryChartOfAccountsTypes: await this.getEmptyDccLocationCOATypes()}] },
                    category: await this.getNewCategory()
                };                
            },
            async addNewClassAndCategoryClick() {
                var newCategory = await this.getNewCategory();
                this.selectedDcc = {
                    department: {
                        ...this.selectedDcc.department,
                        dccClasses: [{
                            isNew: true,
                            dccCategories: [newCategory]
                        }]
                    },
                    class: {
                        isNew: true,
                        dccCategories: [newCategory]
                    },
                    category: newCategory
                }
            },
            async addNewCategoryClick() {
                this.selectedDcc.category = await this.getNewCategory();
            },
            async deleteDcc(dccLevel) {
                if (dccLevel === "Department") {
                    await this.deleteDepartment();
                    return;
                }

                if (dccLevel === "Class") {
                    await this.deleteClass();
                    return;
                }
                
                await this.deleteCategory();
            },
            // Deleting a department takes its classes and categories with it, so there
            // is nothing left to re-enter — drop the selection entirely.
            async deleteDepartment() {
                let department = this.selectedDcc.department;
                let resp = await axios.post("dccs/deleteDepartment", { dccDepartmentId: department.dccDepartmentId });
                if (!resp.data) {
                    this.$appError(this.deleteFailedMessage("Department"));
                    return;
                }

                this.dccs = this.dccs.filter(x => x.dccDepartmentId !== department.dccDepartmentId);
                this.selectedDcc = this.getEmptySelection();
                this.$appSuccess(`Department "${department.name}" deleted successfully.`);
            },
            // A department always keeps at least one class — Edit.vue disables the delete
            // button on the last one — so we only ever fall back to the department.
            async deleteClass() {
                let dccClass = this.selectedClassFromList();
                let resp = await axios.post("dccs/deleteClass", { dccClassId: dccClass.dccClassId });
                if (!resp.data) {
                    this.$appError(this.deleteFailedMessage("Class"));
                    return;
                }

                let department = this.selectedDepartmentFromList();
                department.dccClasses = department.dccClasses.filter(x => x.dccClassId !== dccClass.dccClassId);
                this.selectedDcc = { department: department, class: undefined, category: undefined };
                this.$appSuccess(`Class "${dccClass.name}" deleted successfully.`);
            },
            // A class always keeps at least one category — Edit.vue disables the delete
            // button on the last one — so we only ever fall back to the class itself.
            async deleteCategory() {
                let category = this.selectedDcc.category;
                let resp = await axios.post("dccs/deleteCategory", { dccCategoryId: category.dccCategoryId });
                if (!resp.data) {
                    this.$appError(this.deleteFailedMessage("Category"));
                    return;
                }

                let dccClass = this.selectedClassFromList();
                dccClass.dccCategories = dccClass.dccCategories.filter(x => x.dccCategoryId !== category.dccCategoryId);
                this.selectedDcc = {
                    department: this.selectedDepartmentFromList(),
                    class: dccClass,
                    category: undefined
                };
                this.$appSuccess(`Category "${category.name}" deleted successfully.`);
            },
            deleteFailedMessage(dccLevel) {
                return `DCC ${dccLevel} could not be deleted because it is either in use or no longer exists.`;
            },
            selectedDepartmentFromList() {
                return this.dccs.find(x => x.dccDepartmentId === this.selectedDcc.department?.dccDepartmentId);
            },
            selectedClassFromList() {
                return this.selectedDepartmentFromList()?.dccClasses
                    ?.find(x => x.dccClassId === this.selectedDcc.class?.dccClassId);
            },
            loadDccs(savedDcc) {
                this.dccs = [];
                axios.get("dccs").then(resp => {
                    this.dccs = resp.data;
                    this.selectSavedDcc(savedDcc);
                });
            },
            // Creating a DCC returns no ids, so the selection still holds the isNew placeholders
            // after a save.  Re-point it at the reloaded records - matched on number, which
            // is unique at each level - so nothing keeps reporting itself as new after it has been saved.
            selectSavedDcc(savedDcc) {
                if (!savedDcc) {
                    return;
                }

                let department = this.dccs.find(x => x.number === savedDcc.departmentNumber);
                if (!department) {
                    this.selectedDcc = this.getEmptySelection();
                    return;
                }

                let dccClass = department.dccClasses.find(x => x.number === savedDcc.classNumber);
                this.selectedDcc = {
                    department: department,
                    class: dccClass,
                    category: dccClass?.dccCategories.find(x => x.number === savedDcc.categoryNumber)
                };
            },
        },
        mounted: function () {
            this.displayMessage = 'Are you sure you want to leave without saving?\n\n' +
                'Select \u2018OK\u2019 to discard changes or \u2018Cancel\u2019 to return to editing.';
            this.loadDccs();
        }
    };
</script>
<style scoped lang="scss">
    :deep(.dcc-list-window ) {
        max-height: 750px;
        overflow-y: auto;
    }
</style>
